const countries = {
  "i0": "abkh",
  "i1": "afg",
  "i2": "akr_a_dhe",
  "i3": "alb",
  "i4": "dza",
  "i5": "asm",
  "i6": "and",
  "i7": "ago",
  "i8": "aia",
  "i9": "atg",
  "i10": "arg",
  "i11": "arm",
  "i12": "abw",
  "i13": "aus",
  "i14": "aut",
  "i15": "aze",
  "i16": "bhs",
  "i17": "bhr",
  "i18": "bgd",
  "i19": "brb",
  "i20": "blr",
  "i21": "bel",
  "i22": "blz",
  "i23": "ben",
  "i24": "bmu",
  "i25": "btn",
  "i26": "bol",
  "i27": "bih",
  "i28": "bwa",
  "i29": "bra",
  "i30": "vgb",
  "i31": "brn",
  "i32": "bgr",
  "i33": "bfa",
  "i34": "bdi",
  "i35": "khm",
  "i36": "cmr",
  "i37": "can",
  "i38": "cpv",
  "i39": "cym",
  "i40": "caf",
  "i41": "tcd",
  "i42": "chanisl",
  "i43": "chl",
  "i44": "chn",
  "i45": "cxr",
  "i46": "cck",
  "i47": "col",
  "i48": "com",
  "i49": "cod",
  "i50": "cog",
  "i51": "cok",
  "i52": "cri",
  "i53": "civ",
  "i54": "hrv",
  "i55": "cub",
  "i280": "nld_curacao",
  "i56": "cyp",
  "i57": "cze",
  "i58": "cheslo",
  "i59": "dnk",
  "i60": "dji",
  "i61": "dma",
  "i62": "dom",
  "i63": "deu_east",
  "i64": "ecu",
  "i65": "egy",
  "i66": "slv",
  "i67": "gnq",
  "i68": "eri",
  "i69": "eri_a_eth",
  "i70": "est",
  "i71": "eth",
  "i72": "fro",
  "i73": "flk",
  "i74": "fji",
  "i75": "fin",
  "i76": "fra",
  "i77": "guf",
  "i78": "pyf",
  "i79": "gab",
  "i80": "gmb",
  "i81": "geo",
  "i82": "deu",
  "i83": "gha",
  "i84": "gib",
  "i85": "grc",
  "i86": "grl",
  "i87": "grd",
  "i88": "glp",
  "i89": "gum",
  "i90": "gtm",
  "i91": "gbg",
  "i92": "gin",
  "i93": "gnb",
  "i94": "guy",
  "i95": "hti",
  "i96": "hos",
  "i97": "hnd",
  "i98": "hkg",
  "i99": "hun",
  "i100": "isl",
  "i101": "ind",
  "i102": "idn",
  "i103": "irn",
  "i104": "irq",
  "i105": "irl",
  "i106": "gbm",
  "i107": "isr",
  "i108": "ita",
  "i109": "jam",
  "i110": "jpn",
  "i111": "jey",
  "i112": "jor",
  "i113": "kaz",
  "i114": "ken",
  "i115": "kir",
  "i118": "kos",
  "i119": "kwt",
  "i120": "kgz",
  "i121": "lao",
  "i122": "lva",
  "i123": "lbn",
  "i124": "lso",
  "i125": "lbr",
  "i126": "lby",
  "i127": "lie",
  "i128": "ltu",
  "i129": "lux",
  "i130": "mac",
  "i131": "mkd",
  "i132": "mdg",
  "i133": "mwi",
  "i134": "mys",
  "i135": "mdv",
  "i136": "mli",
  "i137": "mlt",
  "i138": "mhl",
  "i139": "mtq",
  "i140": "mrt",
  "i141": "mus",
  "i142": "myt",
  "i143": "mex",
  "i144": "fsm",
  "i145": "mda",
  "i146": "mco",
  "i147": "mng",
  "i148": "mne",
  "i149": "msr",
  "i150": "mar",
  "i151": "moz",
  "i152": "mmr",
  "i153": "nam",
  "i154": "nru",
  "i155": "npl",
  "i156": "nld",
  "i157": "ant",
  "i158": "ncl",
  "i159": "nzl",
  "i160": "ngokar",
  "i161": "nic",
  "i162": "ner",
  "i163": "nga",
  "i164": "niu",
  "i165": "nfk",
  "i116": "prk",
  "i252": "yem_north",
  "i166": "cyp_nor",
  "i167": "mnp",
  "i168": "nor",
  "i169": "omn",
  "i170": "pak",
  "i171": "plw",
  "i172": "pan",
  "i173": "png",
  "i174": "pry",
  "i175": "per",
  "i176": "phl",
  "i177": "pcn",
  "i178": "pol",
  "i179": "prt",
  "i180": "pri",
  "i181": "qat",
  "i182": "reu",
  "i183": "rou",
  "i184": "rus",
  "i185": "rwa",
  "i193": "wsm",
  "i194": "smr",
  "i195": "stp",
  "i196": "sau",
  "i197": "sen",
  "i198": "srb",
  "i199": "scg",
  "i200": "scg_ex_kos",
  "i201": "syc",
  "i202": "sle",
  "i203": "sgp",
  "i271": "sxm",
  "i204": "svk",
  "i205": "svn",
  "i206": "slb",
  "i207": "som",
  "i208": "som_somland",
  "i209": "zaf",
  "i117": "kor",
  "i210": "sosset",
  "i211": "ssd",
  "i253": "yem_south",
  "i212": "esp",
  "i213": "lka",
  "i186": "stbar",
  "i187": "shn",
  "i188": "kna",
  "i189": "lca",
  "i190": "stmar",
  "i191": "vct",
  "i192": "spm",
  "i214": "sdn",
  "i215": "sur",
  "i216": "sjm",
  "i217": "swz",
  "i218": "swe",
  "i219": "che",
  "i220": "syr",
  "i221": "twn",
  "i222": "tjk",
  "i223": "tza",
  "i224": "tha",
  "i225": "tls",
  "i226": "tgo",
  "i227": "tkl",
  "i228": "ton",
  "i229": "transn",
  "i230": "tto",
  "i231": "tun",
  "i232": "tur",
  "i233": "tkm",
  "i234": "tca",
  "i235": "tuv",
  "i242": "ussr",
  "i236": "uga",
  "i237": "ukr",
  "i238": "are",
  "i239": "gbr",
  "i240": "usa",
  "i241": "ury",
  "i243": "uzb",
  "i245": "vut",
  "i246": "ven",
  "i250": "vnm",
  "i251": "vir",
  "i244": "wlf",
  "i247": "pse",
  "i248": "deu_west",
  "i249": "esh",
  "i254": "yem",
  "i255": "yug",
  "i256": "zmb",
  "i257": "zwe",
  "i258": "ala"
};

export default countries;
